import { FE_BRAND_REVIEWS_CLICK_TO_SCROLL_PDP_DESKTOP_XP_250305 } from "@faire/retailer-settings/FE_BRAND_REVIEWS_CLICK_TO_SCROLL_PDP_DESKTOP_XP_250305";

import {
  useReviewsHoldoutGatedAssignSettingEffect,
  useReviewsHoldoutGatedFESetting,
} from "./useReviewsHoldoutGatedSetting";

export const useSettingBrandReviewsClickToScrollPdpDesktopXP = () =>
  useReviewsHoldoutGatedFESetting(
    FE_BRAND_REVIEWS_CLICK_TO_SCROLL_PDP_DESKTOP_XP_250305,
    false
  );

export const useAssignSettingBrandReviewsClickToScrollPdpDesktopXPEffect = (
  shouldSettingBeAssigned: boolean
) => {
  useReviewsHoldoutGatedAssignSettingEffect(
    FE_BRAND_REVIEWS_CLICK_TO_SCROLL_PDP_DESKTOP_XP_250305,
    shouldSettingBeAssigned
  );
};
